import React from 'react';

import Logo from '@components/logo';
// import '@style/components/login-logo.scss';
import '../../styles/components/login-logo.scss';

function LoginLogo(props) {
  return (
    <p className="logo-container">
      <Logo wrappercClassName="logo" imgClassName="img-logo" />
    </p>
  );
}

export default LoginLogo;
